import { toast } from 'react-toastify';
import { updateAggregateShipment, updateAggregateShipmentForInspection } from '../../services/aggregateDataService';
import { updateFiveMShipment, updateFiveMShipmentForInspection } from '../../services/fiveMDataService';
import { updateTractorShipment, updateTractorShipmentForInspection,getDailyContainerPlanningAB} from '../../services/tractorDataService';
import * as actionTypes from '../ActionTypes';
import { getAggregateDailyContainerPlanning } from '../../services/aggregateDataService';
import moment from "moment";
import { dispatcher } from '../storeHelpers';
import { tractorDataCreatorForStore,aggregateDataCreatorForStore,fiveMDataCreatorForStore} from '../../utils/dataFilter';
import { getFiveMDailyContainerPlanning } from '../../services/fiveMDataService'

const convertYesOrNo = (val) => {
    if (val === 1) {
        return "YES"
    }
    else return "NO"
}
let counterLabel = []
let counterValue = {
  Booked: 0,
  Pending: 0,
  Approved: 0,
  Cancelled: 0,
  Not_Booked: 0,
  Hold:0,
}

const api = store => next => async (action) => {
    if ((action.type === actionTypes.TRACTOR_COLUMN_UPDATED)||(action.type === actionTypes.TRACTOR_INSERT_DROPDOWN_DATA)) {
        try {
                let checkstatus="";
                const apiresponse = await updateTractorShipment(action.payload)
               
                  if(apiresponse.data.IsBooked){
                    checkstatus="Booked"
                  }
                  else{
                    checkstatus="Not Booked"
                  }
                  if(checkstatus!==action.payload.Status){
                    const response = await getDailyContainerPlanningAB(
                        moment(action.payload.date).format("YYYY-MM-DD")
                      );
                    dispatcher(actionTypes.TRACTOR_BOOKING_LOADED, []);
                    dispatcher(
                      actionTypes.TRACTOR_BOOKING_LOADED,
                      tractorDataCreatorForStore(response.data.Resultset1)
                    );
                    counterLabel=[];  
                    for (let i = 0; i < response.data.Resultset2.length; i++) {
                      counterLabel.push(response.data.Resultset2[i]["STATUS"])
                      if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                        counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                      }
                      if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                        counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                      }
                      if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                        counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                      }
                      if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                        counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                      }
                      if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                        counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                      }
                      if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                        counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
                      }
                    }
                  
                    action.payload.setCountData({label : counterLabel, counterData : counterValue}) 
                  }
                
            if ((action.payload.Value === 1) || (action.payload.Value === 0)) {
                toast.success(`Column updated with ${convertYesOrNo(action.payload.Value)}`)
            }
            else toast.success(action.payload.Value?`${action.payload.ColumnName} updated with ${action.payload.Value}` : `${action.payload.ColumnName} updated`)          
            next(action)
        } catch (error) {
            if(error?.response?.data?.Message==="Record Not Found"){
                window.location.reload();
              }
              else{
                toast.error("Unable to update.. Try again");
              }
        }
    }
    else if ((action.type === actionTypes.TRACTOR_COLUMN_UPDATED_FOR_INSPECTION)){
        try {
            await updateTractorShipmentForInspection(action.payload)
            const response = await getDailyContainerPlanningAB(
                moment(action.payload.date).format("YYYY-MM-DD")
              );
               dispatcher(actionTypes.TRACTOR_BOOKING_LOADED, []);
              dispatcher(
                actionTypes.TRACTOR_BOOKING_LOADED,
                tractorDataCreatorForStore(response.data.Resultset1)
              );   
              for (let i = 0; i < response.data.Resultset2.length; i++) {
                counterLabel.push(response.data.Resultset2[i]["STATUS"])
                if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                  counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                  counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                  counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                  counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                  counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                  counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
                }
              }
        
              action.payload.setCountData({label : counterLabel, counterData : counterValue}) 
            if ((action.payload.Value === 1) || (action.payload.Value === 0)) {
                toast.success(`Column updated with ${convertYesOrNo(action.payload.Value)}`)
            }
            else toast.success(`Column updated with ${action.payload.Value}`)
            next(action)
        } catch (error) {
            if(error?.response?.data?.Message==="Record Not Found"){
                window.location.reload();
              }
              else{
                toast.error("Unable to update.. Try again");
              }       
             }
    }
    else if ((action.type === actionTypes.AGGREGATE_COLUMN_UPDATED)||(action.type === actionTypes.AGGREGATE_INSERT_DROPDOWN_DATA)) {
        try {
            let checkstatus="";
            const apiresponse  = await updateAggregateShipment(action.payload)
            if(apiresponse.data.IsBooked){
                checkstatus="Booked"
              }
              else{
                checkstatus="Not Booked"
              }
              if(checkstatus!==action.payload.Status){
                const response = await getAggregateDailyContainerPlanning(
                    moment(action.payload.date).format("YYYY-MM-DD")
                  );
                  dispatcher(
                    actionTypes.AGGREGATE_BOOKING_LOADED,[]
                  );
                  dispatcher(
                    actionTypes.AGGREGATE_BOOKING_LOADED,
                    aggregateDataCreatorForStore(response.data.Resultset1)
                  );
                    counterLabel=[];
                  for (let i = 0; i < response.data.Resultset2.length; i++) {
                    counterLabel.push(response.data.Resultset2[i]["STATUS"])
                    if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                      counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                    }
                    if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                      counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                    }
                    if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                      counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                    }
                    if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                      counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                    }
                    if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                      counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                    }
                    if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                      counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
                    }
                  }
                  action.payload.setCountData({label : counterLabel, counterData : counterValue})
              }
          
            if ((action.payload.Value === 1) || (action.payload.Value === 0)) {
                toast.success(`Column updated with ${convertYesOrNo(action.payload.Value)}`)
            }
            else toast.success(action.payload.Value?`${action.payload.ColumnName} updated with ${action.payload.Value}` : `${action.payload.ColumnName} updated`)
            next(action)
        } catch (error) {
            if(error?.response?.data?.Message==="Record Not Found"){
                window.location.reload();
              }
              else{
                toast.error("Unable to update.. Try again");
              }       
        }
    }
    else if ((action.type === actionTypes.AGGREGATE_COLUMN_UPDATED_FOR_INSPECTION)){
        try {
            await updateAggregateShipmentForInspection(action.payload)
            const response = await getAggregateDailyContainerPlanning(
                moment(action.payload.date).format("YYYY-MM-DD")
              );
              dispatcher(
                actionTypes.AGGREGATE_BOOKING_LOADED,[]
              );
              dispatcher(
                actionTypes.AGGREGATE_BOOKING_LOADED,
                aggregateDataCreatorForStore(response.data.Resultset1)
              );
              for (let i = 0; i < response.data.Resultset2.length; i++) {
                counterLabel.push(response.data.Resultset2[i]["STATUS"])
                if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                  counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                  counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                  counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                  counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                  counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                  counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
                }
              }
              action.payload.setCountData({label : counterLabel, counterData : counterValue})
            if ((action.payload.Value === 1) || (action.payload.Value === 0)) {
                toast.success(`Column updated with ${convertYesOrNo(action.payload.Value)}`)
            }
            else toast.success(`Column updated with ${action.payload.Value}`)
            next(action)
        } catch (error) {
            if(error?.response?.data?.Message==="Record Not Found"){
                window.location.reload();
              }
              else{
                toast.error("Unable to update.. Try again");
              }       
        }
    }
    else if ((action.type === actionTypes.FIVE_M_COLUMN_UPDATED)||(action.type === actionTypes.FIVE_M_INSERT_DROPDOWN_DATA)) {
        try {
            let checkstatus="";
            const apiresponse = await updateFiveMShipment(action.payload)
            if(apiresponse.data.IsBooked){
                checkstatus="Booked"
              }
              else{
                checkstatus="Not Booked"
              }
              if(checkstatus!==action.payload.Status){
             const response = await getFiveMDailyContainerPlanning(
                moment(action.payload.date).format("YYYY-MM-DD")
              );
              dispatcher(
                actionTypes.FIVE_M_BOOKING_LOADED,[]
              );
              dispatcher(
                actionTypes.FIVE_M_BOOKING_LOADED,
                fiveMDataCreatorForStore(response.data.Resultset1)
              );
              counterLabel=[];
              for (let i = 0; i < response.data.Resultset2.length; i++) {
                counterLabel.push(response.data.Resultset2[i]["STATUS"])
                if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                  counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                  counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                  counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                  counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                  counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                  counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
                }
              }
              action.payload.setCountData({label : counterLabel, counterData : counterValue})}
           
            if ((action.payload.Value === 1) || (action.payload.Value === 0)) {
                toast.success(`Column updated with ${convertYesOrNo(action.payload.Value)}`)
            }
            else toast.success(action.payload.Value?`${action.payload.ColumnName} updated with ${action.payload.Value}` : `${action.payload.ColumnName} updated`)
            next(action)
        } catch (error) {
            toast.error("Unable to update.. Try again");
        }
    }
    else if ((action.type === actionTypes.FIVE_M_COLUMN_UPDATED_FOR_INSPECTION)){
        try {
            await updateFiveMShipmentForInspection(action.payload)
            const response = await getFiveMDailyContainerPlanning(
                moment(action.payload.date).format("YYYY-MM-DD")
              );
              dispatcher(
                actionTypes.FIVE_M_BOOKING_LOADED,[]
              );
              dispatcher(
                actionTypes.FIVE_M_BOOKING_LOADED,
                fiveMDataCreatorForStore(response.data.Resultset1)
              );
              for (let i = 0; i < response.data.Resultset2.length; i++) {
                counterLabel.push(response.data.Resultset2[i]["STATUS"])
                if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                  counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                  counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                  counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                  counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                  counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Hold"){
                  counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
                }
              }
              action.payload.setCountData({label : counterLabel, counterData : counterValue})
            if ((action.payload.Value === 1) || (action.payload.Value === 0)) {
                toast.success(`Column updated with ${convertYesOrNo(action.payload.Value)}`)
            }
            else toast.success(`Column updated with ${action.payload.Value}`)
            next(action)
        } catch (error) {
            toast.error("Unable to update.. Try again");
        }
    }
    else {
        next(action)
    }
}

export default api;